module.exports = __webpack_public_path__ + "img/txt.a2255f32.png";